import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import props from '../../../lib/contentLayoutProps/working-at-kingston/layoutProps';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" pageKey="why-kingston">
    <h1>Why Work at Kingston?</h1>

    <p>
      Kingston International School is an exciting environment to begin or continue a teaching career in IB education!
    </p>
    <p>
      Kingston International School offers an IB-PYP bilingual (English/Putonghua) programme for students aged 1 to 11
      years of age. Kingston has three campuses - the Kindergarten and Children's Centre which houses our early years
      programme for children 1 to 4 years of age, a Lower Primary campus for students from Year 1 to Year 3 and an Upper
      Primary campus for students from Year 4 to Year 6. Although we have 3 campuses we are still a small school with a
      community feel. We maintain small class sizes and have an English and a Putonghua class teacher for each class.
    </p>
    <p>
      Kingston has been an authorized IB-PYP school since 2004. The philosophy of the PYP is infused in all aspects of
      our school. Teachers receive IB-PYP training and ongoing support from our PYP coordinators.
    </p>
    <p>
      At Kingston we value teachers who are passionate, enthusiastic and true life long learners. Teachers who thrive in
      a small school environment and value team work both in the classroom and as a whole school are ideal Kingston
      teachers. Our teaching team is comprised of English and Putonghua teachers working side by side in the classroom
      so strong interpersonal skills and evidence of a high level of collaborative planning is essential.
    </p>

    <h3>Community</h3>
    <p>
      Considering we are a small group of educators and students, there is a real community aspect at our school.
      Excellent working relationships are established through consistent positive interactions with fellow staff
      members. Kingston is a wonderful place for staff to collaborate as teachers are ensured planning time with their
      working teams. Teachers who are looking to work in a supportive and nurturing environment, where educators can
      discover their passions and flourish in their careers, will find Kingston to be a great fit.
    </p>

    <h3>Professional Development & Learning</h3>
    <p>
      We are a community of learners. Our professional development program supports continuous growth in teaching and
      learning here at KIS. PD can be found in many different forms, such as In-school IB workshops, outside consultants
      who work with teachers in specialized areas, workshops and conferences within the Asia-Pacific region and beyond
      as well as Online webinars. The aim of our professional development program is to meet the individual needs of
      teachers in their learning journeys.
    </p>
    <p>
      Learning comes in all forms here at Kingston. There is a strong sharing culture amongst staff and frequent sharing
      of teaching practices takes place both formally and informally.
    </p>
    <p>
      Please <a href={process.env.JOB_OPENINGS_URL}>click here</a> to view the current job openings.
    </p>
  </ContentLayout>
);
